module.exports = __webpack_public_path__ + "media/images/pic/godzilla-83a53cca0927f81aa369b25b1de733f7.png";